import React from 'react'
import DatePicker, { DateObject } from 'react-multi-date-picker'
import Toolbar from 'react-multi-date-picker/plugins/toolbar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar } from '@fortawesome/free-solid-svg-icons'
import { DATE_PICKER_SETTINGS } from '../../constants/ClientDashboardConst'
import dayjs from 'dayjs'

const toNativeDate = (d) => {
  if (!d) return null
  if (typeof d.toDate === 'function') return d.toDate()
  if (d instanceof Date) return d
  return dayjs(d).toDate()
}

const DateRangeFilter = ({ disabled, value, onChange }) => {
  const pickerValue = Array.isArray(value)
    ? value.map((d) => new DateObject(toNativeDate(d))).filter(Boolean)
    : null

  return (
    <DatePicker
      disabled={disabled}
      range
      rangeHover
      dateSeparator=" - "
      months={DATE_PICKER_SETTINGS.months}
      weekDays={DATE_PICKER_SETTINGS.weekDays}
      format="DD MMM"
      weekStartDayIndex={DATE_PICKER_SETTINGS.weekStartDayIndex}
      highlightToday={false}
      numberOfMonths={2}
      maxDate={dayjs().local().endOf('day').toDate()}
      value={pickerValue}
      onChange={(dates) => {
        if (!dates?.length) {
          onChange(null)
          return
        }

        onChange(dates.map((d) => dayjs(toNativeDate(d))))
      }}
      plugins={[<Toolbar position="bottom" sort={[]} />]}
      render={(_, openCalendar) => (
        <div className={`mr-10 ${disabled ? 'react-filter-disabled' : ''}`}>
          <div className="react-filter-box filter-input-width-datepicker">
            <div
              title="Rango de fechas"
              onClick={!disabled ? openCalendar : undefined}
              className="react-filter-box-clickable-zone"
            >
              <div className="react-filter-titles">
                {Array.isArray(value) && (
                  <div className="filter-title-overflow">
                    {value.map((d) => dayjs(toNativeDate(d)).format('DD MMM')).join(' - ')}
                  </div>
                )}

                <FontAwesomeIcon
                  icon={faCalendar}
                  style={{ color: disabled ? '#D5D5D5' : '#597fa9' }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    />
  )
}

export default DateRangeFilter
